<template>
  <div class="calico-navbar-menu-view">
    <h2>Navbar Menu</h2>
    <div class="menu-wrapper">
      <button
        ref="trigger"
        class="menu-trigger"
        @click="toggleMenu"
      >
        Open menu
      </button>
      <div
        v-if="isMenuVisible"
        class="menu-container"
      >
        <CalicoNavbarMenu @close="closeMenu">
          <CalicoNavbarMenuItem @click="handleHomeClick">
            <i class="bi bi-house" />
            <span class="body--medium">Home</span>
          </CalicoNavbarMenuItem>

          <CalicoNavbarMenuItem @click="handleFavClick">
            <i class="bi bi-star" />
            <span class="body--medium">Fav</span>
          </CalicoNavbarMenuItem>

          <CalicoNavbarMenuItem @click="handleSettingsClick">
            <i class="bi bi-gear" />
            <span class="body--medium">Settings</span>
          </CalicoNavbarMenuItem>
        </CalicoNavbarMenu>
      </div>
    </div>
  </div>
</template>

<script>
import CalicoNavbarMenu from "@/components/calico/navbarMenu/index.vue";
import CalicoNavbarMenuItem from "@/components/calico/navbarMenuItem/index.vue";

export default {
  name: "NavbarMenuView",
  components: {
    CalicoNavbarMenu,
    CalicoNavbarMenuItem,
  },
  data() {
    return {
      isMenuVisible: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    closeMenu() {
      this.isMenuVisible = false;
    },
    handleHomeClick() {
      alert("Home clicked");
    },
    handleFavClick() {
      alert("Fav clicked");
    },
    handleSettingsClick() {
      alert("Settings clicked");
    }
  },
};
</script>

<style scoped lang="scss">
.calico-navbar-menu-view {
  padding: $space-medium;
}

.menu-wrapper {
  position: relative;
  display: inline-block;
}

.menu-container {
  position: absolute;
  top: 100%;
  left: 0;
  width: max-content;
  z-index: $z-index-dialog;
  border-radius: $radius-small;
}
</style>